import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../../../components";

export default class BlockedOfficersModal extends Component {
	constructor(props) {
		super(props);

		this.initialState = {
			show: false,
			officerId: null,
			officerName: "",
			reasonNote: "",
			validation: "",
		};

		this.state = { ...this.initialState };
	}

	openModal = ({ officerId, officerName }) =>
		this.setState({
			show: true,
			officerId,
			officerName,
		});

	resetModal = () => this.setState(this.initialState);

	updateReasonNote = ({ target: { value } }) => this.setState({ reasonNote: value });

	isInvalid = () => {
		const { reasonNote } = this.state;
		// not valid if empty
		return !reasonNote;
	};

	/**  Updates the officers blocked status if the required data has been validated */
	onOfficerBlock = () => {
		const { reasonNote, officerId } = this.state;
		const { updateBlockedOfficerStatus } = this.props;

		if (this.isInvalid()) {
			this.setState({ validation: "has-error" });
			return;
		}
		this.setState({ validation: null });
		updateBlockedOfficerStatus(officerId, true, reasonNote);
	};

	render() {
		const { lang } = global;
		const { show, reasonNote, officerName, validation } = this.state;

		return (
			<Modal
				show={show}
				onHide={this.resetModal}
			>
				<Modal.Header closeButton>
					<Modal.Title>{`${lang.t("Blocking")} ${officerName}`}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className={`form-group ${validation}`}>
						<label
							htmlFor="reason-note"
							className="control-label"
						>
							{lang.t("Please specify a reason")}
						</label>
						<input
							id="reason-note"
							className="form-control"
							type="textarea"
							onChange={this.updateReasonNote}
							value={reasonNote}
						/>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						id="deny-estimate"
						className="btn btn-primary"
						onClick={this.onOfficerBlock}
					>
						{lang.t("Block")}
					</button>
					<button
						type="button"
						className="btn btn-default"
						id="cancel-deny-estimate"
						onClick={this.resetModal}
					>
						{lang.t("Cancel")}
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

BlockedOfficersModal.propTypes = {
	updateBlockedOfficerStatus: PropTypes.func.isRequired,
};
